function truncateText(originalText, maxLength = 150) {


    return originalText.length > maxLength ? `${originalText.substring(0, maxLength)}...` : originalText;

}

export default truncateText;